import React from 'react'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import { TogglePill, getPillBackground } from './TogglePill'

const styles = {
  toggleContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '12px',
  },
  toggleText: {
    fontSize: '18px',
    fontWeight: 600,
    letterSpacing: '0.08em',
    opacity: 0.6,
    userSelect: 'none',
  },
}

class PillToggle extends React.Component {
  render() {
    const {
      classes,
      isOn,
      label,
      onClick,
      disabled = false,
      activeColor = '#1976d2',
    } = this.props

    const interactive = !disabled && !!onClick
    const pillBackground = getPillBackground(isOn, disabled, activeColor)
    const textColor = interactive ? (isOn ? activeColor : '#000') : undefined
    const textOpacity = interactive ? 1 : undefined

    return (
      <div
        className={classes.toggleContainer}
        style={interactive ? { cursor: 'pointer' } : undefined}
        onClick={interactive ? onClick : undefined}
      >
        <TogglePill
          isOn={isOn}
          background={pillBackground}
          width={72}
          height={28}
          borderRadius={14}
          thumbSize={22}
          thumbOnLeft={44}
          showOnOff
        />
        <Typography
          className={classes.toggleText}
          style={{ color: textColor, opacity: textOpacity }}
        >
          {label}
        </Typography>
      </div>
    )
  }
}

export default withStyles(styles)(PillToggle)
